export class Money {
  public static format = (amt: number | null, currency = "usd") => {
    if (amt == null) return "—";
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency.toUpperCase(),
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amt / 100);
  };
}